import * as actionTypes from './actionTypes'

const initialState = {
  events: [],
  isEventsLoading: false,
  error: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.EVENTS_REQUESTED:
      return {
        ...state,
        isEventsLoading: true,
        error: null,
      }

    case actionTypes.EVENTS_SUCCEED:
      return {
        ...state,
        isEventsLoading: false,
        events: action.events,
      }

    case actionTypes.EVENTS_FAIL:
      return {
        ...state,
        isEventsLoading: false,
        error: action.error,
      }

    case actionTypes.UPDATE_EVENT:
      const updatedEvents = state.events || []
      const editedEvent = action.event

      for (let i = 0; i < updatedEvents.length; i++) {
        if (updatedEvents[i].id === editedEvent.id) {
          console.log('update candidate:')
          console.log(updatedEvents[i])

          updatedEvents[i] = editedEvent

          console.log('new value:')
          console.log(updatedEvents[i])
        }
      }

      return {
        ...state,
        events: updatedEvents,
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/analytics/reducer.js